import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

const PaymentCancelled = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const proposalId = searchParams.get("proposal_id");

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <img src={logo} alt="Trusted James" className="h-10 w-auto" />
        </Link>

        <div className="space-y-6">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto">
            <XCircle className="w-10 h-10 text-muted-foreground" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-bold text-foreground mb-2">
              Payment not completed
            </h1>
            <p className="text-muted-foreground">
              Your payment was not processed. No charges were made to your account.
            </p>
          </div>

          <div className="space-y-3">
            {proposalId && (
              <Button
                variant="gold"
                size="lg"
                className="w-full"
                onClick={() => navigate(`/payment-success?proposal_id=${proposalId}`)}
              >
                Try Again
              </Button>
            )}
            <Button
              variant="outline"
              size="lg"
              className="w-full"
              onClick={() => navigate("/")}
            >
              Go Home
            </Button>
            <p className="text-xs text-muted-foreground">
              If you believe this is an error, please contact support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
